
import { styled } from '@mui/system';
import { Button } from '@mui/material';

const FooterArrowNavigation = styled('footer')(({theme}) => ({
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0
    },
    background: '#fff',
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(1),
    position: 'relative',
    "&.previewSmallScreen": {
      borderRadius: '5%',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0,1,0,1)
    }
  }));

const StyledArrowButton = styled(Button)(({ theme }) => ({
  minHeight: theme.spacing(5),
  width:'130px',
  height:'40px',
  border: `1px solid ${theme.vars.palette.primary.main}`,
  "& > div": { display: 'flex' }, // [GM]: make the arrows icon to be centrally aligned
  '& svg':{
    width: '16px',
    height: '15px'
  },
  "&:disabled": {
      border: 'none',
      "svg": { color: 'unset' },
      // backgroundColor: theme.vars.palette.blueGrey[100]
  },
  [theme.breakpoints.down('sm')]: {
    '@media (max-height: 480px)': {
      minHeight: 'unset'
    }
  }
}));

const StyledNextArrowButton = styled(StyledArrowButton)(({ theme }) => ({
  background: theme.vars.palette.primary.main,
  color: theme.vars.palette.primary.textButtonColor,
  "&:hover": {
      [theme.breakpoints.up('sm')]: {
        boxShadow: `2px 4px 12px 2px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`
      },
      background: theme.vars.palette.primary.main
  },
  "&.isLastNavigate": {
      width: 325,
      [theme.breakpoints.down('sm')]: {
      width: 200
      },
  }
}))
const StyledBackArrowButton = styled(StyledArrowButton)(({ theme }) => ({
  "svg": { color: theme.vars.palette.primary.main },
  "&:hover": {
      boxShadow: `0px 1px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`,
      background: '#fff'
  },

}))


export { FooterArrowNavigation, StyledArrowButton, StyledNextArrowButton, StyledBackArrowButton }